export const CONSTANTS = {
	// chain specific constants
	// ENTRY_POINT_ADDRESS: "0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789",
	// KERNEL_FACTORY_ADDRESS: "0x7e3B523aDA6EC3fE6DC4e1c107Ed6DD641B6d4fc",
	// ECDSA_VALIDATOR_ADDRESS: "0x93513fB6ea522d47ed8595f1B5037bd88578A914",
	// KERNEL_IMPLEMENTATION: "0x29C69905F09908C70da2D67a2B3d52B22E71F241",

	SALT: 0,
	API_URL: "https://api.0xgasless.com",
	SUPPORTED_TEST_CHAIN_IDS: [5, 80001, 421613, 97],
	SUPPORTED_MAIN_CHAIN_IDS: [1, 137, 42161, 56, 250, 1284, 8453, 1088],
};

export const getConstants = (chainId: number) => {
	switch (chainId) {
		case 8453:
			return {
				ENTRY_POINT_ADDRESS:
					"0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789",
				KERNEL_FACTORY_ADDRESS:
					"0x6C08Aff3D2d66883b3111Cef4bAEd15Bb253D86A",
				ECDSA_VALIDATOR_ADDRESS:
					"0x2C30524335133FdB278506b49A2727D2DF4451f5",
				KERNEL_IMPLEMENTATION:
					"0x7235528B231f5d98f236549d55fa28a569256303",
			};
		case 1088:
			return {
				ENTRY_POINT_ADDRESS:
					"0xD1398353742A5c2c5264DfEa6c000E2137730008",
				KERNEL_FACTORY_ADDRESS:
					"0xd6Cd3a9b50263f64b83C0FA70471833185008A23",
				ECDSA_VALIDATOR_ADDRESS:
					"0x9e65D68989e4eC9A93851b0da80706A98657A6fE",
				KERNEL_IMPLEMENTATION:
					"0x76A0c4E39b5718BD505741ae265Fe16eedFc255D",
			};
		default:
			return {
				ENTRY_POINT_ADDRESS:
					"0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789",
				KERNEL_FACTORY_ADDRESS:
					"0x7e3B523aDA6EC3fE6DC4e1c107Ed6DD641B6d4fc",
				ECDSA_VALIDATOR_ADDRESS:
					"0x93513fB6ea522d47ed8595f1B5037bd88578A914",
				KERNEL_IMPLEMENTATION:
					"0x29C69905F09908C70da2D67a2B3d52B22E71F241",
			};
	}
};

export const defaultChainData = getConstants(1);
export type ChainData = typeof defaultChainData;
